export default "__VITE_ASSET__skx5PwCq__"